import { render, staticRenderFns } from "./InterventionInfo.vue?vue&type=template&id=0ce4ed2f"
import script from "./InterventionInfo.vue?vue&type=script&lang=js"
export * from "./InterventionInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports